(() => {
  const script = document.getElementById('SbHoustonggReferral');
  const referral = window.SBHoustonggReferral;
  const consent = window.SBAnalyticsConsent;
  if (!script || script.dataset.track !== 'true' || !referral || !consent) return;

  let synced = '';
  let inFlight = false;
  let hasStored = referral.saved;
  const synchronize = async () => {
    const allowed = consent.analyticsAllowed();
    if (allowed === null || inFlight || typeof window.SBCart?.updateAttributes !== 'function') return;
    const current = allowed === true ? referral.current : null;
    // Do not write an empty cart just because an untracked visitor declined analytics.
    if (!current && !hasStored) return;
    const attributes = {
      hg_guide: current?.guide || '', hg_layout: current?.layout || '',
      hg_placement: current?.placement || '', hg_referred_at: current?.referredAt || '',
      hg_analytics_eligible: current ? 'true' : '',
    };
    const signature = JSON.stringify(attributes);
    if (synced === signature) return;
    inFlight = true;
    try {
      await window.SBCart.updateAttributes(attributes, { source: 'houstongg-referral' });
      synced = signature;
      hasStored = Boolean(current);
    } catch (_) {
      // Attribution must never prevent adding a product or checking out.
    } finally {
      inFlight = false;
      // A consent change while the cart request was pending must still be applied.
      if (allowed !== consent.analyticsAllowed()) void synchronize();
    }
  };
  consent.whenReady(() => { void synchronize(); });
  document.addEventListener('sb:cart-system-ready', () => { void synchronize(); });
  document.addEventListener('cart:updated', () => { void synchronize(); });
  void synchronize();
})();
